
import React, { useEffect } from "react";
import { View, Button, Platform, Dimensions, StyleSheet, Pressable, Image, Text } from "react-native";

// Firebase imports
import { getAuth, GoogleAuthProvider, signInWithCredential } from "@react-native-firebase/auth"; // mobile modular API
import auth from "@react-native-firebase/auth";
import { app } from "../../../firebase/firebaseAuth"; // your firebase config
import { getAuth as getWebAuth, GoogleAuthProvider as WebGoogleAuthProvider, signInWithPopup } from "firebase/auth";


// Google Sign-In for mobile
import { GoogleSignin } from "@react-native-google-signin/google-signin";
import { COLORS, FONTS } from "../../../utils";

const { width } = Dimensions.get("screen");
const SignInWithGoogleAccount = ({ googleLogin }) => {
  const Google1 = require("../../assets/images/google.png");
  useEffect(() => {
    if (Platform.OS !== "web") {
      // Configure Google Sign-In only for mobile
      GoogleSignin.configure({
        webClientId: "1041058281114-v4ohu6ngp8vh8dg85a1bghasshea46td.apps.googleusercontent.com"
      });
    }
  }, []);

  const signInWithGoogle = async () => {
    try {
      if (Platform.OS === "web") {
        const provider = new WebGoogleAuthProvider(); // ✅ web provider
        const authWeb = getWebAuth(app);
        const result = await signInWithPopup(authWeb, provider);
        console.log("WEB Google User:", result.user);
        const userInfo = {
          email: result.user.email,
          id: result.user.uid,
          name: result.user.displayName,
          given_name: result.user.displayName,
        }
        googleLogin(userInfo)
        console.log(userInfo)
      }

      else {
        // ✅ Mobile Google login
        await GoogleSignin.hasPlayServices({ showPlayServicesUpdateDialog: true });

        // Sign in with Google
        const result = await GoogleSignin.signIn();
        const { idToken } = result.data


        console.log(idToken)
        const tokens = await GoogleSignin.getTokens();
        const googleCredential = auth.GoogleAuthProvider.credential(idToken, tokens.accessToken);

        // Firebase ke andar user sign in
        const userCredential = await auth().signInWithCredential(googleCredential);

        const userInfo = {
          email: userCredential.user.email,
          id: userCredential.user.uid,
          name: userCredential.user.displayName,
          given_name: userCredential.user.displayName,
        }
        //  console.log(result)
        console.log({userInfo})
   
        googleLogin(userInfo)
      }
    } catch (error) {
      console.error("Google Sign-In Error:", error?.code ?? "", error?.message ?? error);
    }
  };

  return (
    <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
      <Pressable onPress={signInWithGoogle} style={styles.googleButton}>
        <Image source={Google1} style={styles.googleIcon} />
        <Text style={styles.googleButtonText}>Login with Google</Text>
      </Pressable>
    </View>
  );
};

export default SignInWithGoogleAccount;

const styles = StyleSheet.create({
  googleButton: {
    height: 50,
    width: Platform.OS === "web" ? "50%" : width - 92,
    maxWidth: 436,
    minWidth: 325,
    borderRadius: 46,
    borderWidth: 1,
    borderColor: COLORS.primarybordercolor,
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    marginTop: 13,
  },
  googleIcon: {
    height: 20,
    width: 20,
    marginRight: 20,
  },
  googleButtonText: {
    fontFamily: FONTS.PoppinsMedium,
    fontSize: 14,
    fontWeight: "500",
    color: COLORS.black,
  },
})